import { status } from "./status"

export default {
  status,
}
